import React, { Fragment } from 'react';
import LogView from 'components/LogView/LogView.react';
import LogViewEntry from 'components/LogView/LogViewEntry.react';

import StatusIndicator from 'components/StatusIndicator/StatusIndicator.react';
import styles from './EngineView.scss';

const STATUS_COLOR = {
  new: 'orange',
  pending: 'blue',
  running: 'blue',
  failed: 'red',
  cancelled: 'gray',
  complete: 'green',
  active: 'green',
};

const STATUS_CONTENT = {
  new: 'NEW',
  pending: 'PENDING',
  running: 'RUNNING',
  failed: 'FAILED',
  cancelled: 'CANCELLED',
  complete: 'COMPLETE',
  active: 'ACTIVE',
};

const BuildLogView = ({ logs, phase }) => {
  if (!logs) {
    return null;
  }

  const color = STATUS_COLOR[phase.toLowerCase() || ''];
  const status = STATUS_CONTENT[phase.toLowerCase() || ''];

  return (
    <div className={[styles.holder].join(' ')}>
      <LogView fixed>
        {
          logs.map(({ objectId, text }, i) => {
            let rowText = text;
            if (rowText.includes('Pulling image')) {
              rowText = 'Pulling image';
            }
            if (rowText.includes('Pushing image')) {
              rowText = 'Pushing image';
            }

            return (
              <Fragment key={`log-entry-${objectId}`}>
                <LogViewEntry
                  text={rowText}
                  enableDate={false}
                  customClass="buildLogs" />
                {
                  logs.length === i + 1 &&
                    <Fragment>
                      <LogViewEntry
                        text=" "
                        enableDate={false}
                        customClass="buildLogs" />

                      {
                        phase !== 'Complete' && phase !== 'Cancelled'
                          ? <div className={styles.lll}>
                            <StatusIndicator color={color} status={status} loading />
                          </div>
                          : <div className={styles.lll}>
                            <StatusIndicator color={color} status={status} />
                          </div>
                      }
                    </Fragment>
                }
              </Fragment>
            );
          })
        }
      </LogView>
    </div>
  );
};

export default BuildLogView;
